import {
  Spacing
} from 'UI'

export default theme => ({
  concernedAudiencesGroup: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: ({ noPaper }) => noPaper ? 0 : Spacing(5)
  },
  concernedAudiencesText: {
    overflow: 'hidden',
    transition: 'all 0.15s ease',
    position: 'relative'
  },
  icon: {
    paddingLeft: 4
  },
  shadow: {
    width: '100%',
    height: 130,
    background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%)',
    position: 'absolute',
    bottom: 0,
    display: ({ open }) => open && 'none'
  },
  iconCheck: {
    marginRight: 8,
    color: theme.secondary[0]
  },
  concernedAudienceItem: {
    display: 'flex',
    alignItems: 'baseline'
  }
})
